import { render } from "./Supplier.vue?vue&type=template&id=c0b8b114&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"

import "./Supplier.vue?vue&type=style&index=0&id=c0b8b114&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b8b114"]])

export default __exports__